import client from "../api-client";

const ONVERIFY_URL = "admin/onverify";

export const getOnVerify = () => {
  return client(ONVERIFY_URL).then(async (response) => {
    return await response;
  });
};

export const updateOnVerify = async (data) => {
  return await client(ONVERIFY_URL, { method: "POST", body: data });
};
